import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";

const StyledContainer = styled("div")(({ theme }) => ({
  "& > blockquote": {
    borderLeft: `3px solid ${theme.palette_custom.grey}`,
    paddingLeft: "1rem",
  },
  p: {
    margin: 0,
    minHeight: "1rem",
  },
}));
const StaticEditorContent = ({ html }) => {
  return (
    <Paper elevation={1} sx={{ minHeight: "70vh", p: 1 }}>
      <StyledContainer dangerouslySetInnerHTML={{ __html: html }} />
    </Paper>
  );
};

export default StaticEditorContent;
